export const T = {
  en_GB: {
    enterCode: "Please enter a code",
    invalidCode: "Invalid code",
    title: "Two-Factor Authentication",
    enterBackupCode: "Enter one of your backup codes",
    enterAppCode: "Enter the code from your authenticator app",
    backupCode: "Backup Code",
    verificationCode: "Verification Code",
    backupCodePlaceholder: "Enter backup code",
    appCodePlaceholder: "Enter 6-digit code",
    trustDevice: "Trust this device",
    verify: "Verify",
    useApp: "Use authenticator app instead",
    useBackupCode: "Use a backup code",
    backToLogin: "Back to login",
  },
  nb_NO: {
    enterCode: "Skriv inn en kode",
    invalidCode: "Ugyldig kode",
    title: "Tofaktorautentisering",
    enterBackupCode: "Skriv inn en av reservekodene dine",
    enterAppCode: "Skriv inn koden fra autentiseringsappen din",
    backupCode: "Reservekode",
    verificationCode: "Bekreftelseskode",
    backupCodePlaceholder: "Skriv inn reservekode",
    appCodePlaceholder: "Skriv inn den 6-sifrede koden",
    trustDevice: "Stol på denne enheten",
    verify: "Bekreft",
    useApp: "Bruk autentiseringsappen i stedet",
    useBackupCode: "Bruk en reservekode",
    backToLogin: "Tilbake til innlogging",
  },
} as const;
